export default __webpack_public_path__ + "static/media/hht2_ep01_timeline_q03_b.e3d7f3b0.png";